import { flatMap, forEach, groupBy } from 'lodash';
import getDatalakeEvent from './dataLakeEvents';

/**
 * requestIdleCallback polyfill
 */
import '../../utils/requestIdleCallback';

export const ENDPOINT_HOST = process.env.INTERNAL_AWS_API_HOST || process.env.AWS_API_HOST || '';
export const ENDPOINT_PATH = '/eventslogging/v1/event';
export const ENDPOINT = `${ENDPOINT_HOST}${ENDPOINT_PATH}`;

const stack = [];
let handle;

export default async function sendToDatalake(config) {
    try {
        const event = await getDatalakeEvent(config);

        stack.push(event);
    // eslint-disable-next-line no-empty
    } catch (err) { }

    if (!handle) {
        handle = requestIdleCallback(() => {
            try {
                if (stack.length) {
                    const events = groupBy(stack.filter(Boolean), 'Name');

                    // cleanup, now that the stack has been reorganized for processing
                    stack.length = 0;
                    handle = null;

                    forEach(events, eventGroup => {
                        const body = JSON.stringify({
                            ...eventGroup[0],
                            EventData: flatMap(eventGroup, e => e.EventData),
                        });

                        fetch(ENDPOINT, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body,
                        });
                    });
                }
            // eslint-disable-next-line no-empty
            } catch (err) { }
        }, { timeout: 20000 });
    }
}
